import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import httpRequest from '@/utils/httpRequest'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.prototype.$http = httpRequest // ajax请求方法
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
